// extracted by mini-css-extract-plugin
export default {"loaderV2":"Loader_loaderV2__tA1cc","backdrop":"Loader_backdrop__c3-2d","backdropDark":"Loader_backdropDark__6Rkbf","progressContainer":"Loader_progressContainer__Vsevw"};